export const dateRangeError = 'The first field must contain a date earlier than the second field';
export const incompleteFilterError = 'Please fill in all the fields of the range date picker';
export const noFilterError = 'You must select at least one filter';